import { TIPTAP_COLLAPSIBLE_LIST_TYPE } from 'ricos-content';
import { findNodeClosestToSelection } from 'ricos-plugins';
import { RicosPluginToolbarNames, createShortcut } from 'ricos-types';
import { DEFAULTS } from './defaults.js';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import CollapsibleListSettingsModal from './modals/SettingsModals.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { COLLAPSIBLE_LIST_TYPE } from './types.js';
import 'wix-rich-content-editor-common';
import './tiptap/defaults.js';
import './icons/InsertPluginIcon.js';
import 'react';
import '@tiptap/core';
import './consts.js';
import '@tiptap/pm/state';
import 'lodash';
import 'ricos-context';
import 'wix-rich-content-ui-components';
import './components/modal-components/CollapsibleListSettings.js';
import '@wix/design-system';
import 'wix-rich-content-plugin-commons';
import './style-inject.es-e7b07dd7.js';
import './dataHooks.js';
import '@tiptap/pm/view';
import 'ricos-schema';
import 'ricos-schema/dist/statics/collapsible_list.defaults.json';
import './tiptap/component.js';
import 'classnames';
import './collapsible-list-component.rtlignore-b2e49eb3.js';
import './collapsible-list-pair.rtlignore-d44a6457.js';
import './components/ExpandCollapseButton.js';
import './icons/ArrowIcon.js';
import './components/NewPairButton.js';
import 'prop-types';
import './icons/PlusIcon.js';
import './tiptap/utils.js';
import './icons/DndIcon.js';
import './tiptap/keyboardShortcuts.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginCollapsibleList = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: COLLAPSIBLE_LIST_TYPE,
    tiptapExtensions,
    getAddButtons,
    toolbar: {
      names: [RicosPluginToolbarNames.COLLAPSIBLE_LIST],
      getButtons: getToolbarButtons,
      isVisible: (_, { adapter: { tiptapEditor } }) => {
        return findNodeClosestToSelection(tiptapEditor, TIPTAP_COLLAPSIBLE_LIST_TYPE) !== null;
      },
      resolveReferenceElement: (tiptapEditor) => {
        var _a, _b;
        return (_b = (_a = findNodeClosestToSelection(tiptapEditor, TIPTAP_COLLAPSIBLE_LIST_TYPE)) == null ? void 0 : _a.element) != null ? _b : null;
      }
    },
    shortcuts: [
      createShortcut({
        name: "MoveToNextElementTab",
        description: "ShortcutsSheet_CollapsibleList_MoveToNextElement",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Tab",
          windows: "Tab"
        },
        enabled: false,
        command: () => {
        }
      }),
      createShortcut({
        name: "MoveToNextElementEnter",
        description: "ShortcutsSheet_CollapsibleList_MoveToNextElement",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Enter",
          windows: "Enter"
        },
        enabled: false,
        command: () => {
        }
      }),
      createShortcut({
        name: "SelectEntireList",
        description: "ShortcutsSheet_CollapsibleList_SelectTheEntireList",
        group: "ShortcutsSheet_Section_CollapsibleList",
        keys: {
          macOs: "Meta+A",
          windows: "Ctrl+A"
        },
        enabled: false,
        command: () => {
        }
      })
    ],
    __exports: {
      SettingsModal: CollapsibleListSettingsModal
    }
  };
};

export { pluginCollapsibleList };
//# sourceMappingURL=editor.js.map
